export default "__VITE_ASSET__DiwoKw3a__"